import React, { Component } from 'react';
import Grid from '@mui/material/Grid';
import { styled } from '@mui/system';
import MemberCard from './Cards/MemberCard.js';
import concatTokens from '../services/concatTokens.js';
import Button from './Button.js';
import Text from './Text.js';
import { colors } from '../theme/index.js';
import i18n from '../localization/i18n.js';
import tokens from '../localization/tokens.js';
const MemberListHeader = styled(Grid)({
  backgroundColor: colors.surface,
  borderLeft: `${colors.surface} solid 5px`,
  boxShadow: '0 1px 2px rgba(0, 0, 0, .15)',
  cursor: 'pointer',
  height: 'auto',
  marginBottom: '0',
  minHeight: '70px',
  padding: '10px',
  position: 'relative',
  borderBottom: '2px solid rgba(0, 0, 0, 0.09)'
});
class MemberList extends Component {
  state = {
    employeeList: this.props.employees,
    memberCards: [],
    loadIndex: 50
  };
  componentDidMount() {
    const firstMemberLoad = this.props.employees.slice(0, 50);
    const firstMemberCards = firstMemberLoad.map((member, i) => /*#__PURE__*/React.createElement(MemberCard, {
      testid: i === 0 ? 'account-employee-card' : undefined,
      key: concatTokens(member.classID, member.userID),
      member: member,
      division: this.props.divisions[member.divisionID],
      class: this.props.classesData[member.classID],
      sendNotification: () => this.props.toggleNotificationModal(member.userID),
      onEditEmployee: () => this.props.editEmployee(member),
      terminateEmployee: () => this.props.terminateEmployee(member),
      onManageEmployee: () => this.props.manageEmployee(member),
      whitelabel: this.props.whitelabel,
      onClick: () => {
        window.location.href = this.props.isMasterSite ? `/members/${member.userID}` : `/employee/${member.accountID}/${member.userID}`;
      }
    }));
    this.setState({
      memberCards: firstMemberCards
    });
  }
  componentWillReceiveProps(nextProps) {
    if (nextProps.employees !== this.state.employeeList) {
      const firstMemberLoad = nextProps.employees.slice(0, 50);
      const firstMemberCards = firstMemberLoad.map((member, i) => /*#__PURE__*/React.createElement(MemberCard, {
        testid: i === 0 ? 'account-employee-card' : undefined,
        key: concatTokens(member.classID, member.userID),
        member: member,
        division: this.props.divisions[member.divisionID],
        class: this.props.classesData[member.classID],
        sendNotification: () => this.props.toggleNotificationModal(member.userID),
        onEditEmployee: () => this.props.editEmployee(member),
        terminateEmployee: () => this.props.terminateEmployee(member),
        onManageEmployee: () => this.props.manageEmployee(member),
        onClick: () => {
          window.location.href = this.props.isMasterSite ? `/members/${member.userID}` : `/employee/${member.accountID}/${member.userID}`;
        }
      }));
      this.setState({
        employeeList: nextProps.employees,
        memberCards: firstMemberCards,
        loadIndex: 50
      });
    }
  }
  _loadMore = () => {
    const newBatch = this.state.employeeList.slice(this.state.loadIndex, this.state.loadIndex + 50);
    const newComponents = newBatch.map(member => /*#__PURE__*/React.createElement(MemberCard, {
      key: concatTokens(member.classID, member.userID),
      member: member,
      division: this.props.divisions[member.divisionID],
      class: this.props.classesData[member.classID],
      sendNotification: () => this.props.toggleNotificationModal(member.userID),
      onEditEmployee: () => this.props.editEmployee(member),
      terminateEmployee: () => this.props.terminateEmployee(member),
      onManageEmployee: () => this.props.manageEmployee(member),
      onClick: () => {
        window.location.href = this.props.isMasterSite ? `/members/${member.userID}` : `/employee/${member.accountID}/${member.userID}`;
      }
    }));
    this.setState({
      loadIndex: this.state.loadIndex + 50,
      memberCards: this.state.memberCards.concat(newComponents)
    });
  };
  _handleMenuClick = event => {
    this.setState({
      anchorEl: event.currentTarget
    });
  };
  _handleCloseMenu = () => {
    this.setState({
      anchorEl: null
    });
  };
  _editUser = () => {
    this._handleCloseMenu();
    this.props.onEditEmployee();
  };
  _notifyUser = () => {
    this._handleCloseMenu();
    this.props.sendNotification();
  };
  render() {
    return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(MemberListHeader, {
      container: true,
      alignItems: "center"
    }, /*#__PURE__*/React.createElement(Grid, {
      item: true,
      xs: 2,
      sm: 2,
      md: 1
    }), /*#__PURE__*/React.createElement(Grid, {
      item: true,
      xs: 4,
      sm: 4,
      md: 6
    }, /*#__PURE__*/React.createElement(Text, {
      medium: true,
      bold: true
    }, i18n.t(tokens.labels.classesAndDivisions.name))), /*#__PURE__*/React.createElement(Grid, {
      item: true,
      xs: 1,
      sm: 1,
      md: 1,
      style: {
        textAlign: 'center'
      }
    }, /*#__PURE__*/React.createElement(Text, {
      medium: true,
      bold: true,
      align: "center"
    }, i18n.t(tokens.titles.division))), /*#__PURE__*/React.createElement(Grid, {
      item: true,
      xs: 2,
      sm: 2,
      md: 2,
      style: {
        textAlign: 'center'
      }
    }, /*#__PURE__*/React.createElement(Text, {
      medium: true,
      bold: true,
      align: "center"
    }, i18n.t(tokens.titles.class))), /*#__PURE__*/React.createElement(Grid, {
      item: true,
      xs: 1,
      sm: 1,
      md: 1,
      style: {
        textAlign: 'center'
      }
    }, /*#__PURE__*/React.createElement(Text, {
      medium: true,
      bold: true,
      align: "center"
    }, i18n.t(tokens.labels.claims.status))), /*#__PURE__*/React.createElement(Grid, {
      item: true,
      xs: 2,
      sm: 1,
      md: 1,
      style: {
        textAlign: 'center'
      }
    })), this.state.memberCards, this.state.loadIndex < this.state.employeeList.length && /*#__PURE__*/React.createElement(Button, {
      onClick: this._loadMore,
      color: "primary",
      customStyle: {
        margin: '20px auto 0',
        display: 'block'
      }
    }, "LOAD MORE"));
  }
}
export default MemberList;